import Loadable from "react-loadable"
import Loading from "../views/components/shared/Loading"

import LogOut from "../views/pages/LogOut"
import NotFound from "../views/pages/NotFound"

const AsyncSignIn = Loadable({
		loader: () => import("../views/pages/SignIn"),
		loading: Loading,
	}),
	AsyncVerification = Loadable({
		loader: () => import("../views/pages/Verification"),
		loading: Loading,
	}),
	AsyncUnregisterVerification = Loadable({
		loader: () => import("../views/pages/UnregisterVerification"),
		loading: Loading,
	}),
	AsyncCSOLogin = Loadable({
		loader: () => import("../views/pages/CSOLogin"),
		loading: Loading,
	}),
	AsyncSignUp = Loadable({
		loader: () => import("../views/pages/SignUp"),
		loading: Loading,
	}),
	AsyncForgotPassword = Loadable({
		loader: () => import("../views/pages/ForgotPassword"),
		loading: Loading,
	}),
	AsyncForgotPasswordWithMobile = Loadable({
		loader: () => import("../views/pages/ForgotPasswordWithMobile"),
		loading: Loading,
	}),
	AsyncForgotEmail = Loadable({
		loader: () => import("../views/pages/ForgotEmail"),
		loading: Loading,
	}),
	AsyncUnRegister = Loadable({
		loader: () => import("../views/pages/UnRegister"),
		loading: Loading,
	}),
	AsyncAccount = Loadable({
		loader: () => import("../views/pages/Account"),
		loading: Loading,
	}),
	AsyncContactUs = Loadable({
		loader: () => import("../views/pages/ContactUs"),
		loading: Loading,
	}),
	AsyncTransactions = Loadable({
		loader: () => import("../views/pages/Transactions"),
		loading: Loading,
	}),
	AsyncRewards = Loadable({
		loader: () => import("../views/pages/Rewards"),
		loading: Loading,
	}),
	AsyncProfile = Loadable({
		loader: () => import("../views/pages/Profile"),
		loading: Loading,
	}),
	AsyncCards = Loadable({
		loader: () => import("../views/pages/Cards"),
		loading: Loading,
	}),
	AsyncCardDetails = Loadable({
		loader: () => import("../views/pages/CardDetails"),
		loading: Loading,
	}),
	AsyncAddCard = Loadable({
		loader: () => import("../views/pages/AddCard"),
		loading: Loading,
	}),
	AsyncChangePassword = Loadable({
		loader: () => import("../views/pages/ChangePassword"),
		loading: Loading,
	}),
	AsyncTransactionDetails = Loadable({
		loader: () => import("../views/pages/TransactionDetails"),
		loading: Loading,
	}),
	AsyncResetPassword = Loadable({
		loader: () => import("../views/pages/ResetPassword"),
		loading: Loading,
	}),
	AsyncTransferBalance = Loadable({
		loader: () => import("../views/pages/TransferBalance"),
		loading: Loading,
	}),
	AsyncLandingPage = Loadable({
		loader: () => import("../views/pages/LandingPage"),
		loading: Loading,
	}),
	AsyncReportLossPage = Loadable({
		loader: () => import("../views/pages/ReportLoss"),
		loading: Loading,
	}),
	AsyncVerifyGoldCardAddressPage = Loadable({
		loader: () => import("../views/pages/VerifyGoldCardAddress"),
		loading: Loading,
	}),
	AsyncVerifyOTP = Loadable({
		loader: () => import("../views/pages/VerifyOTP"),
		loading: Loading,
	})

const localeRegex = ":locale(en|km)?"
const param = "(mobile|email)"
const Routes = [
	{
		path: `/${localeRegex}/sign-in`,
		isPrivate: false,
		component: AsyncSignIn,
	},
	{
		path: `/${localeRegex}/sign-up/${param}`,
		isPrivate: false,
		component: AsyncSignUp,
	},
	{
		path: `/${localeRegex}/forgot-password`,
		isPrivate: false,
		component: AsyncForgotPassword,
	},
	{
		path: `/${localeRegex}/forgot-password-mobile`,
		isPrivate: false,
		component: AsyncForgotPasswordWithMobile,
	},
	{
		path: `/${localeRegex}/reset-password/:mid/:ts/:sig`, // This path have an issue with "+", "%2b" symbol. It will return the 404 error when url have "+", "%2b" symbol.
		isPrivate: false,
		component: AsyncResetPassword,
	},
	{
		path: `/${localeRegex}/reset-password`, // Alternative path for reset-password to using query string instead of params
		isPrivate: false,
		component: AsyncResetPassword,
	},
	{
		path: `/${localeRegex}/forgot-email`,
		isPrivate: false,
		component: AsyncForgotEmail,
	},
	{
		path: `/${localeRegex}/verification/:mid/:cn/:ts`, // This path have an issue with "+", "%2b" symbol. It will return the 404 error when url have "+", "%2b" symbol.
		isPrivate: false,
		component: AsyncVerification,
	},
	{
		path: `/${localeRegex}/verification`, // Alternative path for verification to using query string instead of params
		isPrivate: false,
		component: AsyncVerification,
	},
	{
		path: `/${localeRegex}/unregisterVerification/:mid/:cn`,
		isPrivate: false,
		component: AsyncUnregisterVerification,
	},
	{
		path: `/${localeRegex}/csologin/:Param`,
		isPrivate: false,
		component: AsyncCSOLogin,
	},
	{
		path: `/${localeRegex}/verify-otp`,
		isPrivate: true,
		component: AsyncVerifyOTP,
	},
]

const PrivateRoutes = [
	{
		path: `/${localeRegex}/account`,
		isPrivate: true,
		component: AsyncAccount,
	},
	{
		path: `/${localeRegex}/unregister`,
		isPrivate: true,
		component: AsyncUnRegister,
	},
	{
		path: `/${localeRegex}/contact-us`,
		isPrivate: true,
		component: AsyncContactUs,
	},
	{
		path: `/${localeRegex}/transactions`,
		isPrivate: true,
		exact: true,
		component: AsyncTransactions,
	},
	{
		path: `/${localeRegex}/transactions/detail`,
		isPrivate: true,
		exact: true,
		component: AsyncTransactions,
	},
	{
		path: `/${localeRegex}/transactions/:receiptNo/:autoID`,
		isPrivate: true,
		component: AsyncTransactionDetails,
	},
	{
		path: `/${localeRegex}/cards`,
		isPrivate: true,
		exact: true,
		component: AsyncCards,
	},
	{
		path: `/${localeRegex}/cards/transfer/detail`,
		isPrivate: true,
		component: AsyncTransferBalance,
	},
	{
		path: `/${localeRegex}/cards/add-card`,
		isPrivate: true,
		component: AsyncAddCard,
	},
	{
		path: `/${localeRegex}/cards/report-loss/:cardNo`,
		isPrivate: true,
		component: AsyncReportLossPage,
	},
	{
		path: `/${localeRegex}/cards/verify-gold-card-address`,
		isPrivate: true,
		component: AsyncVerifyGoldCardAddressPage,
	},
	{
		path: `/${localeRegex}/cards/detail`,
		isPrivate: true,
		component: AsyncCardDetails,
	},
	{
		path: `/${localeRegex}/rewards`,
		isPrivate: true,
		component: AsyncRewards,
	},
	{
		path: `/${localeRegex}/profile`,
		isPrivate: true,
		exact: true,
		component: AsyncProfile,
	},
	{
		path: `/${localeRegex}/profile/change-password`,
		isPrivate: true,
		component: AsyncChangePassword,
	},
]

const SharedRoutes = [
	{
		path: `/${localeRegex}/logout`,
		isPrivate: true,
		component: LogOut,
	},
	{
		path: `/${localeRegex}`,
		exact: true,
		isPrivate: false,
		component: AsyncLandingPage,
	},
	{
		path: `/${localeRegex}/landing`,
		isPrivate: false,
		component: AsyncLandingPage,
	},
	{
		path: `/${localeRegex}/*`,
		isPrivate: false,
		status: 404,
		component: NotFound,
	},
]

export { Routes, PrivateRoutes, SharedRoutes, localeRegex }



// WEBPACK FOOTER //
// ./src/configs/Routes.js